/**
 * Server Is Production Mode condition alias
 */
export const UMB_IS_SERVER_PRODUCTION_MODE_CONDITION_ALIAS = 'Umb.Condition.Server.IsProductionMode';
